<template>
    <generic-dosage-choice-row :dosage-choice="dosageChoice.dosage"/>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { DosageRepeat } from '@/service/models/common/query-dosage/dosage-choices';

export default defineComponent({
    props: {
        dosageChoice: {
            type: Object as PropType<DosageRepeat>,
            required: true,
        },
    },
})
</script>
